import router from '../../router/index';

/**
 * Navigation utility function that uses Vue Router
 * @param {string} path - The path to navigate to
 */
export const push = (path) => {
    router.push(path);
};
